module.exports = __webpack_public_path__ + "img/hudong.d8d99edc.png";